export default "__VITE_ASSET__Dx6M3jdZ__"